/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';


export const getCodeBlocks = (feature: BaseNode): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const project: ProjectConfiguration = feature.project;
    const SERIAL_PORT_FEATURE_ID = feature.getSettingValue('SERIAL_PORT');
    const serialPortFeature = project.getFeature(SERIAL_PORT_FEATURE_ID);
    if (!SERIAL_PORT_FEATURE_ID || !serialPortFeature) {
        return [];
    }
    const SERIAL_PORT = `SER_${serialPortFeature.getSettingValue('NAME')}`;
    const MODE = feature.getSettingValue('MODE');
    const varName = `ser_${SERIAL_PORT}_buf`;
    const funcName = `ser_${SERIAL_PORT}_parse`;
    let parseCode = '';

    if (MODE === '1') {
        const PACKET_START = feature.getSettingValue('PACKET_START');
        const PACKET_END = feature.getSettingValue('PACKET_END');
        parseCode = `
    dim index_start as byte=1
    dim index_end as byte=1
    dim packet_start as string="${PACKET_START}"
    dim packet_end as string="${PACKET_END}"
    while index_start<>0 and index_end<>0
        data=""
        if packet_start<>"" then
            index_start=instr(1,${varName}, packet_start,1)
        end if
        if packet_end<>"" then
            index_end=instr(1,${varName}, packet_end,1)
            if index_start<>0 and index_end<>0 then
                data=mid(${varName}, index_start+len(packet_start), index_end-index_start-len(packet_start))
                ${varName}=mid(${varName}, index_end+len(packet_end),255)
            end if
        else
            index_end=0
        end if
        if data<>"" then
        complete_data=packet_start+data+packet_end
        '****ser_${SERIAL_PORT}_parse****'
        end if
    wend
    `;
    } else {
        parseCode = `
if data<>"" then
'****ser_${SERIAL_PORT}_parse****'
${varName} = ""
end if`;
    }
    const PACKET_START = feature.getSettingValue('PACKET_START');
    const PACKET_END = feature.getSettingValue('PACKET_END');
    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `declare sub ser_${SERIAL_PORT}_parse(byref serdata as string)`,
        template: `
declare sub ser_${SERIAL_PORT}_parse(byref serdata as string)
    `,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: `sub ser_${SERIAL_PORT}_parse()`,
        template: `
sub ser_${SERIAL_PORT}_parse(byref serdata as string)
    ${varName} = ${varName} + serdata
    dim data as string=${varName}
    dim complete_data as string=${varName}
    ${parseCode}
    'reset if buffer is too long and no packet found
    if len(${varName})>200 then
        ${varName}=""
    end if
end sub
    `,
    });

    blocks.push({
        location: 'on_ser_data_arrival',
        blockType: BlockType.CODE,
        id: `if ser.num=${SERIAL_PORT} then`,
        template: `
if ser.num=${SERIAL_PORT} then
    dim data as string=ser.getdata(255)
    '****SER_${SERIAL_PORT}_data_available****'
end if`,
    });

    blocks.push({
        location: 'DEVICE_TBS_DIMS',
        blockType: BlockType.CODE,
        id: `dim ${varName} as string=""`,
        template: `dim ${varName} as string=""`,
    });


    const links = project.getNodeLinks(feature, 'data_available');
    if (links.length > 0 && SERIAL_PORT !== '') {
        blocks.push({
            location: `SER_${SERIAL_PORT}_data_available`,
            blockType: BlockType.CODE,
            id: `ser_${SERIAL_PORT}_parse`,
            template: `ser_${SERIAL_PORT}_parse(data)`,
        });

        for (let i = 0; i < links.length; i++) {
            const link = links[i];
            blocks.push({
                location: `ser_${SERIAL_PORT}_parse`,
                blockType: BlockType.CODE,
                id: link.getSourceId(),
                template: `'****${link.getSourceId()}****'`,
            });
        }
    }
    return blocks;
};
